
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Response} from '../core/Response';
import {FieldModelResponse} from '../core/Response';

/**
 * LeverageListResponse struct
 */
class LeverageListResponse extends Response {
  /**
   * Initialize struct
   * @param {!Response=} parent
   * @param {!Array=} leverages
   * @param {!number=} defaultLeverage
   * @constructor
   */
  constructor (parent = new Response(), leverages = [], defaultLeverage = 0) {
    super()
    super.copy(parent)
    this.Leverages = leverages
    this.DefaultLeverage = defaultLeverage
  }

  /**
   * Copy struct (shallow copy)
   * @this {!LeverageListResponse}
   * @param {!LeverageListResponse} other Other struct
   * @returns {!LeverageListResponse} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.Leverages != null) {
      this.Leverages = []
      for (let item of other.Leverages) {
        if (item != null) {
          let tempItem
          tempItem = item
          this.Leverages.push(tempItem)
        } else {
          this.Leverages.push(null)
        }
      }
    } else {
      this.Leverages = null
    }
    if (other.DefaultLeverage != null) {
      this.DefaultLeverage = other.DefaultLeverage
    } else {
      this.DefaultLeverage = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!LeverageListResponse}
   * @returns {!LeverageListResponse} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new LeverageListResponseModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new LeverageListResponseModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!LeverageListResponse}
   * @param {!LeverageListResponse} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof LeverageListResponse)) {
      throw new TypeError('Instance of LeverageListResponse is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!LeverageListResponse}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      Leverages: ((this.Leverages != null) ? Array.from(this.Leverages, item => ((item != null) ? item : null)) : null),
      DefaultLeverage: ((this.DefaultLeverage != null) ? this.DefaultLeverage : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return LeverageListResponse.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!LeverageListResponse} other Object value
   * @returns {!LeverageListResponse} Created struct
   */
  static fromObject (other) {
    return new LeverageListResponse().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!LeverageListResponse}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return LeverageListResponse.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!LeverageListResponse}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 7004
  }
}

export { LeverageListResponse };

/**
 * Fast Binary Encoding LeverageListResponse field model
 */
class FieldModelLeverageListResponse extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelResponse(buffer, 4 + 4)
    this.Leverages = new fbe.FieldModelVector(new fbe.FieldModelUInt32(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4), buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
    this.DefaultLeverage = new fbe.FieldModelUInt32(buffer, this.Leverages.fbeOffset + this.Leverages.fbeSize)
  }

  /**
   * Get the core.Response field model
   * @this {!FieldModelLeverageListResponse}
   * @returns {!FieldModelResponse} core.Response field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelLeverageListResponse}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelLeverageListResponse}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.Leverages.fbeSize + this.DefaultLeverage.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelLeverageListResponse}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.Leverages.fbeExtra + this.DefaultLeverage.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelLeverageListResponse}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelLeverageListResponse.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelLeverageListResponse}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 7004
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelLeverageListResponse}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelLeverageListResponse}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.Leverages.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Leverages.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Leverages.fbeSize

    if ((fbeCurrentSize + this.DefaultLeverage.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.DefaultLeverage.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.DefaultLeverage.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelLeverageListResponse}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelLeverageListResponse}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelLeverageListResponse}
   * @param {!LeverageListResponse} fbeValue Default value, defaults is new LeverageListResponse()
   * @returns {!LeverageListResponse} LeverageListResponse value
   */
  get (fbeValue = new LeverageListResponse()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelLeverageListResponse}
   * @param {!LeverageListResponse} fbeValue LeverageListResponse value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.Leverages.fbeSize) <= fbeStructSize) {
      this.Leverages.get(fbeValue.Leverages)
    } else {
      fbeValue.Leverages.length = 0
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Leverages.fbeSize

    if ((fbeCurrentSize + this.DefaultLeverage.fbeSize) <= fbeStructSize) {
      fbeValue.DefaultLeverage = this.DefaultLeverage.get()
    } else {
      fbeValue.DefaultLeverage = 0
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.DefaultLeverage.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelLeverageListResponse}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelLeverageListResponse}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelLeverageListResponse}
   * @param {!LeverageListResponse} fbeValue LeverageListResponse value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelLeverageListResponse}
   * @param {LeverageListResponse} fbeValue LeverageListResponse value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.Leverages.set(fbeValue.Leverages)
    this.DefaultLeverage.set(fbeValue.DefaultLeverage)
  }
}

export { FieldModelLeverageListResponse };

/**
 * Fast Binary Encoding LeverageListResponse model
 */
class LeverageListResponseModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelLeverageListResponse(this.buffer, 4)
  }

  /**
   * Get the LeverageListResponse model
   * @this {!LeverageListResponseModel}
   * @returns {!FieldModelLeverageListResponse} model LeverageListResponse model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!LeverageListResponseModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!LeverageListResponseModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return LeverageListResponseModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!LeverageListResponseModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelLeverageListResponse.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!LeverageListResponseModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!LeverageListResponseModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!LeverageListResponseModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!LeverageListResponseModel}
   * @param {!LeverageListResponse} value LeverageListResponse value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!LeverageListResponseModel}
   * @param {!LeverageListResponse} value LeverageListResponse value, defaults is new LeverageListResponse()
   * @return {!object} Deserialized LeverageListResponse value and its size
   */
  deserialize (value = new LeverageListResponse()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new LeverageListResponse(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new LeverageListResponse(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!LeverageListResponseModel}
   * @param {!number} prev Previous LeverageListResponse model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { LeverageListResponseModel };
